// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-Footer{padding:.75rem;text-align:center;box-shadow:0 1rem 3rem rgba(0,0,0,.175)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
